import React from 'react';
import { useQuery } from '@apollo/client';
import { PageContainer } from '@ant-design/pro-layout';
import { Col, Row, Divider } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser,
  faUserGroup,
  faBuilding,
  faGlobe,
} from '@fortawesome/free-solid-svg-icons';
import { HeroButton } from 'components/layout';
import { GET_MY_ROLES_AND_CURRENT_USER_ROLE } from 'gql/auth';

const Projects = () => {
  const { data, loading } = useQuery(GET_MY_ROLES_AND_CURRENT_USER_ROLE);
  return (
    <PageContainer ghost loading={loading} header={{ title: 'Projects' }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8} lg={6} xxl={4}>
          <HeroButton
            icon={<FontAwesomeIcon icon={faUser} className="hero-btn-icon" />}
            title="My Project(s)"
            to="/projects"
            search={`?teamMember=${data?.me?.id}`}
          />
        </Col>
        {data?.myCurrentUserRole?.department && (
          <Col xs={24} sm={12} md={8} lg={6} xxl={4}>
            <HeroButton
              icon={
                <FontAwesomeIcon icon={faUserGroup} className="hero-btn-icon" />
              }
              title="My Department Project(s)"
              to="/projects"
              search={`?department=${data?.myCurrentUserRole?.department?.id}`}
            />
          </Col>
        )}
        {data?.myCurrentUserRole?.faculty && (
          <Col xs={24} sm={12} md={8} lg={6} xxl={4}>
            <HeroButton
              icon={
                <FontAwesomeIcon icon={faBuilding} className="hero-btn-icon" />
              }
              title="My Faculty Project(s)"
              to="/projects"
              search={`?faculty=${data?.myCurrentUserRole?.faculty?.id}`}
            />
          </Col>
        )}
        <Col xs={24} sm={12} md={8} lg={6} xxl={4}>
          <HeroButton
            icon={<FontAwesomeIcon icon={faGlobe} className="hero-btn-icon" />}
            title="All Project(s)"
            to="/projects"
          />
        </Col>
      </Row>
      <Divider />
    </PageContainer>
  );
};

export default Projects;
